import { Grid as MantineGrid, GridProps } from '@mantine/core';
import { forwardRef } from 'react';

export interface ThemedGridProps extends GridProps {
  responsive?: boolean;
}

interface GridComponent extends React.ForwardRefExoticComponent<ThemedGridProps & React.RefAttributes<HTMLDivElement>> {
  Col: typeof MantineGrid.Col;
}

const Grid = forwardRef<HTMLDivElement, ThemedGridProps>(
  ({ responsive = true, children, ...rest }, ref) => {
    return (
      <MantineGrid ref={ref} {...rest}>
        {children}
      </MantineGrid>
    );
  }
) as GridComponent;

Grid.displayName = 'Grid';

// Attach subcomponents
Grid.Col = MantineGrid.Col;

export default Grid;
